var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkCopy3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D122B620-42FC-441B-8729-C38BA19C983C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0CDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0CDFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Request_Detail",
    transform: "translate(-445.000000, -732.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 712.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(435.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-link-copy-3",
    transform: "translate(10.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(1.333333, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5266352,5.2864 C11.1866737,5.2864 10.7363737,5.27887059 10.1757353,5.27887059 C8.80843381,5.27887059 7.68417497,4.1472 7.68417497,2.76705882 L7.68417497,0.3456 C7.68417497,0.155105882 7.5320869,0 7.34346788,0 L3.36084804,0 C1.50224241,0 0,1.52545882 0,3.39501176 L0,11.5079529 C0,13.4693647 1.57381327,15.0588235 3.51591822,15.0588235 L9.44660726,15.0588235 C11.2985031,15.0588235 12.8,13.5431529 12.8,11.6720941 L12.8,5.62522353 C12.8,5.43397647 12.6486575,5.27962353 12.4592929,5.28037647 C12.1409517,5.28263529 11.7592405,5.2864 11.5266352,5.2864",
    id: "Fill-3",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47501176,0.427143529 C9.24988235,0.192978824 8.85684706,0.354108235 8.85684706,0.678625882 L8.85684706,2.66413176 C8.85684706,3.49688471 9.54277647,4.18206118 10.3755294,4.18206118 C10.9003294,4.18808471 11.6291765,4.18959059 12.2480941,4.18808471 C12.5650824,4.18733176 12.7262118,3.80860235 12.5063529,3.57970824 C11.712,2.75373176 10.2896941,1.27344941 9.47501176,0.427143529",
    id: "Fill-1",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22061176,9.70752 C8.53007059,9.70752 8.78155294,9.95900235 8.78155294,10.2684612 C8.78155294,10.57792 8.53007059,10.8286494 8.22061176,10.8286494 L4.1216,10.8286494 C3.81214118,10.8286494 3.56141176,10.57792 3.56141176,10.2684612 C3.56141176,9.95900235 3.81214118,9.70752 4.1216,9.70752 L8.22061176,9.70752 Z M6.67023059,5.94718118 C6.97968941,5.94718118 7.23117176,6.19866353 7.23117176,6.50812235 C7.23117176,6.81758118 6.97968941,7.06831059 6.67023059,7.06831059 L4.12152471,7.06831059 C3.81206588,7.06831059 3.56133647,6.81758118 3.56133647,6.50812235 C3.56133647,6.19866353 3.81206588,5.94718118 4.12152471,5.94718118 L6.67023059,5.94718118 Z",
    id: "Combined-Shape",
    fill: "#004CC4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkCopy3);
export default __webpack_public_path__ + "static/media/icon-link-copy-3.a2fb064e8e8980b591a104d2300f86d5.svg";
export { ForwardRef as ReactComponent };